import React, { useContext, useEffect, useRef, useState } from "react";
import AnnotationContext from "../../../../context/annotation/AnnotationContext";
import AddClassificationPathologyIcon from "../../../../components/SVGComponents/Tools/AddClassificationPathologyIcon";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../../../context/theme/ThemeContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";

const ClassificationBox = ({ classification }) => {
  const { classificationStateStore, addStudyAnnotation, addedAnnotation } = useContext(AnnotationContext);
  const {showFindingsHighlighted,showAboveThresholdScore,
    showProbablilityScores} = useContext(studyviewerContext);
  const { getAlterColor, theme ,themeName} = useContext(themeContext);
  const {isChildStudyActive, setActiveTool} = useContext(ViewportContext);

  const [showInfo, setShowInfo] = useState(false);
  const tooltipStyle = {
    root: {display:'flex',alignItems:'center' },
  };
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowInfo(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <>
      <div id="1"
        style={{
          height: "22px",
          width: "98px",
          backgroundColor: `${!classification?.aiPredicted ? getAlterColor("grey","#ccd9ff") : classification?.colorCode === "#FFFFFF" ? getAlterColor("inherit"," #CCD9FF") : classification?.colorCode}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: "5px",
          cursor: "pointer",
          position: "relative",
          border: `${classification?.colorCode === "#FFFFFF" ? `1px solid ${getAlterColor("white","#0078D4")}` : "none"}`, 
        }}
        onClick={() => {
          if(isChildStudyActive) return;
          setShowInfo((prev) => !prev);
        }}
        ref={ref}
      >
        <span
          style={{
            marginLeft: "5px",
            fontSize: "12px",
            fontWeight: "500",
            color:`${classification?.colorCode === "#FFFFFF" ? getAlterColor("#FFFFFF","#000000"):getAlterColor("#FFFFFF","#000000")}`
          }}
        >
          {classification.classificationName}
        </span>
        {!isChildStudyActive && <><div id="2" style={{
          height: "100%",
          width: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: getAlterColor("#d9d9d9","#0078d4"),
          opacity:`${classification?.aiPredicted ?"28%":themeName==='light'?"80%":"28%"}`,
          borderRadius: "0px 5px 5px 0px",
          position: "relative",
        }}>
            
        </div>
        <div id="3" style={{
          position: "absolute",
          right: "0px",
          height: "100%",
          width: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor:`${classification?.colorCode === "#FFFFFF"?getAlterColor('grey','#2382cc'):''}`,
          borderRadius:"4px 4px"
        }}>
        <AddClassificationPathologyIcon/>
        </div></>}
        {showInfo && (
          <div className="modal-scroll classification-pathology-popup" style={{borderRadius:'10px'}}>
           <ul className="dropdown-menu-pathology scrollable-menu modal-scroll-annotation" >
           {
              classification.pathologies.map(pathology => {
                    return (
                      <li
                        style={{
                          padding: "4px 0px",
                          cursor: `${
                            addedAnnotation.some(
                              (item) => item.id == pathology.id
                            )
                              ? "not-allowed"
                              : "pointer"
                          }`,
                          backgroundColor: `${
                            addedAnnotation.some(
                              (item) => item.id == pathology.id
                            )
                              ? theme.palette.actionDetailsHover
                              : ""
                          }`,
                          borderRadius: `${
                            addedAnnotation.some(
                              (item) => item.id == pathology.id
                            )
                              ? "0px"
                              : "10px"
                          }`,
                        }}
                        key={pathology.id}
                        onClick={(event) => {
                          event.stopPropagation();
                          if (
                            addedAnnotation.some(
                              (item) => item.id == pathology.id
                            )
                          ) {
                            return;
                          }
                          // setActiveTool("RectangleROI");
                          addStudyAnnotation(pathology.id);
                        }}
                      >
                        <a style={{ display: "flex" }} id={pathology.id}>
                          <>
                            <div
                              className="classification-pathology"
                              style={{
                                boxSizing: "border-box",
                                fontWeight: `${
                                  showFindingsHighlighted &&
                                  pathology.aiPredicted &&
                                  pathology.prediction !== 0 &&
                                  pathology.prediction !== null
                                    ? "bold"
                                    : ""
                                }`,
                                height: "30px",
                              }}
                            >
                              <span
                                className="viewer-li-text"
                                style={{
                                  color: `${
                                    showFindingsHighlighted &&
                                    addedAnnotation.some(
                                      (item) => item.id == pathology.id
                                    )
                                      ? pathology.aiPredicted &&
                                        pathology.prediction !== 0 &&
                                        pathology.prediction !== null
                                        ? getAlterColor(
                                            "rgb(255,255,255)",
                                            "#000"
                                          )
                                        : getAlterColor(
                                          "rgba(255,255,255,0.4)",
                                          "#000"
                                        )
                                      : pathology.aiPredicted &&
                                        pathology.prediction !== 0 &&
                                        pathology.prediction !== null
                                      ? getAlterColor(
                                          "rgba(255,255,255)",
                                          "#000"
                                        )
                                      : getAlterColor(
                                          "rgba(255,255,255,0.7)",
                                          "#000"
                                        )
                                  }`,
                                  display: "inline-block",
                                  width: "170px",
                                }}
                              >
                                {pathology.name}
                              </span>
                              {showProbablilityScores && (
                                <span
                                  style={{
                                    color: `${
                                      showFindingsHighlighted &&
                                      addedAnnotation.some(
                                        (item) => item.id == pathology.id
                                      )
                                        ? pathology.aiPredicted &&
                                          pathology.prediction !== 0 &&
                                          pathology.prediction !== null
                                          ? getAlterColor(
                                              "rgb(255,255,255)",
                                              "#000"
                                            )
                                          :getAlterColor("rgba(255,255,255,0.4)","#000")
                                        : pathology.aiPredicted &&
                                          pathology.prediction !== 0 &&
                                          pathology.prediction !== null
                                        ? getAlterColor(
                                            "rgb(255,255,255)",
                                            "#000"
                                          )
                                        : getAlterColor(
                                            "rgba(255,255,255,0.7)",
                                            "#000"
                                          )
                                    }`,
                                  }}
                                >{`${
                                  pathology.prediction === null
                                    ? ""
                                    : showAboveThresholdScore
                                    ? pathology.prediction > pathology.threshold
                                      ? (pathology.prediction * 100).toFixed(
                                          0
                                        ) + "%"
                                      : ""
                                    : (pathology.prediction * 100).toFixed(0) +
                                      "%"
                                }`}</span>
                              )}
                            </div>
                          </>
                        </a>
                      </li>
                    );
                  })
                
              }
              </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default ClassificationBox;



